export const tooltip_options = {
    place:"top",
    arrowColor:'rgba(50,50,50,0.9)',
    backgroundColor:'rgba(50,50,50,0.9)',
    effect:"solid",
    delayHide:50,
    textColor:'#fff',
    delayUpdate:100,
    scrollHide: true
}